import { render } from "./Ndaylive_event.vue?vue&type=template&id=0bd8de43&scoped=true"
import script from "./Ndaylive_event.vue?vue&type=script&lang=js"
export * from "./Ndaylive_event.vue?vue&type=script&lang=js"

import "./Ndaylive_event.vue?vue&type=style&index=0&id=0bd8de43&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd8de43"]])

export default __exports__